import React, { useState, FC } from "react";
import { Avatar } from "src/components/Avatar";
import { PropertiesCard } from "src/components/Properties/PropertiesCard";
import { Link } from "src/components/Link";
import { Show } from "src/components/PrivateRoute/Show";
import { ONLY_FOR } from "src/components/PrivateRoute/types";
import { getImageUrl } from "src/utils/getImageUrl";
import { getItemPath } from "src/utils/getItemPath";
import { PATHNAMES } from "src/constants/routes";
import { IInquiry } from "src/@types/inquiries";
import { Sizes } from "src/@types/sizes";
import { ActionButtons } from "./ActionButtons";
import { getPropertiesInquiry } from "./constants";

export const InquiryInfoCard: FC<IInquiry> = ({ ...industry }) => {
  const {
    id,
    isFavorite: isFavoriteIndustry,
    host,
    is_host,
    is_active_deal,
  } = industry || {};

  const [isFavorite, setIsFavorite] = useState(isFavoriteIndustry);

  const userFullName = `${host.first_name} ${host.last_name}`;

  return (
    <div className="flex items-start gap-10 gl:min-w-100">
      <div className="flex flex-col gap-5 flex-1 p-5 rounded-20 border border-black-base/20">
        <div className="flex justify-start items-center gap-2 font-medium">
          <Avatar
            sizeVariant={Sizes.M}
            avatarUrl={getImageUrl(host.avatarUrl)}
          />
          <div className="text-purple-base text-lg">
            <Link
              className="!scale-100 hover:underline transition-all"
              href={getItemPath(PATHNAMES.USER_PROFILE, { id: host.id })}
            >
              {userFullName}
            </Link>
            <div className="flex items-center gap-2">
              <span>{host.location.city}</span>
              <img
                className="w-6.5 aspect-square object-cover rounded-full"
                src={getImageUrl(host.location.country.icon)}
                alt={host.location.country.title}
                title={host.location.country.title}
              />
            </div>
          </div>
        </div>

        <PropertiesCard properties={getPropertiesInquiry(industry)} />

        <Show onlyFor={ONLY_FOR.AUTHORIZED}>
          <ActionButtons
            id={id}
            isFavorite={isFavorite}
            setIsFavorite={setIsFavorite}
            isHost={is_host}
            isActiveDeal={is_active_deal}
          />
        </Show>
      </div>
    </div>
  );
};
